export default __webpack_public_path__ + "static/media/shop.513708f2.svg";